import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { isUngatedForSeatsSelector } from '../selectors/GatingSelectors';
import { apiNameToProductIdSelector } from '../selectors/SelectorUtils';
const OPERATIONS_HUB_PRODUCTS = ['operations-hub-starter', 'operations-hub-professional', 'operations-hub-enterprise'];
export const useShouldHideOpsOrSuitePage = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const hasAllLevelsOfOperationsHubsInProductData = useAppSelector(state => {
    const apiNameToProductId = apiNameToProductIdSelector(state);
    if (!apiNameToProductId) return false;
    return OPERATIONS_HUB_PRODUCTS.every(product => product in apiNameToProductId);
  });
  return isAppAuth && !isUngatedForSeats && !hasAllLevelsOfOperationsHubsInProductData;
};